export default __webpack_public_path__ + "static/media/wstETH.3f648703.png";